import axios from "axios";


//const API_BASE = "http://localhost:3000";
const API_BASE = "https://srv.omdcgroup.com";

export const loginUser = async (user_id, password) => {
  try {
    const response = await axios.post(`${API_BASE}/login`, { user_id, password });
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

export const getUserAccess = async (userId) => {
  try {
    const res = await fetch(`${API_BASE}/user-access/${userId}`);
    return await res.json();
  } catch (err) {
    console.error("Error fetching user access:", err);
    return { access: [] };
  }
};


export const getinduk = async () => {
  try {
    const response = await axios.get(`${API_BASE}/list_induk`);
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

export const getmasteraset = async (nm_induk) => {
  try {
    const response = await axios.get(`${API_BASE}/list_aset`, {
      params: { nm_induk }
    });
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

// 🧩 Ambil master barang sesuai grup
export const getMasterBarang = async (grup_brg) => {
  if (!grup_brg) {
    return { status: "error", message: "Parameter grup_brg wajib diisi" };
  }

  try {
    const response = await axios.get(`${API_BASE}/masterbarang`, {
      params: { grup_brg }, // <-- kirim grup sebagai query param
    });
    return response.data;
  } catch (error) {
    console.error("❌ Gagal mengambil master barang:", error);
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

// 🧩 Ambil daftar grup
export const getGroupBarang = async () => {
  try {
    const response = await axios.get(`${API_BASE}/groupbarang`);
    return response.data;
  } catch (error) {
    console.error("❌ Gagal mengambil group barang:", error);
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

export const updateBarang = async (data) => {
  try {
    const formData = new FormData();
    formData.append("kd_brg", data.kd_brg);
    formData.append("nm_barang", data.nm_barang);
    formData.append("val_3", data.val_3);
    formData.append("sts_brg", data.sts_brg);
    formData.append("val_2", data.val_2);
    if (data.gambar) formData.append("gambar", data.gambar);
    
    const response = await axios.post(`${API_BASE}/updatebarang`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Gagal update barang:", error);
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};